






























import { defineComponent, PropType, reactive, ref, watch } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { formatDateOnly } from "@/lib/time";
import { FormFields, FormValues } from "@/types";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseForm from "@/components/BaseForm";
import { TaxCertification, TaxFormDraft } from "../../../types";

export default defineComponent({
  name: "CertificationForm",
  components: { BaseCheckbox, BaseForm },
  props: {
    draft: { type: Object as PropType<TaxFormDraft | null>, default: null },
  },
  setup(props, { emit }) {
    const certification = reactive<TaxCertification>({
      tinCorrect: props.draft?.certification?.tinCorrect ?? false,
      usOrCanadaPerson: props.draft?.certification?.usOrCanadaPerson ?? false,
      signature: props.draft?.certification?.signature ?? "",
    });
    const values = ref<FormValues>({
      signature: certification.signature,
      date: formatDateOnly(new Date(), "MM/dd/yyyy"),
    });

    const fields: FormFields = [
      {
        name: "signature",
        label: $t("Full legal name as signature"),
        rules: ["required"],
        validationMode: "aggressive",
      },
      {
        name: "date",
        label: $t("Current Date"),
        appendIcon: "sci-calendar",
        disabled: true,
      },
    ];

    const emitState = () => {
      emit("updateDraft", { certification: { ...certification } });
      emit("setValid", certification.tinCorrect && certification.usOrCanadaPerson && !!certification.signature);
    };

    const onCheckboxInput = (name: "tinCorrect" | "usOrCanadaPerson", value: boolean) => {
      certification[name] = value;
      emitState();
    };

    watch(
      () => values.value.signature as string,
      signature => {
        certification.signature = signature;
        emitState();
      }
    );

    emitState();

    return { certification, values, fields, onCheckboxInput };
  },
});
